document.addEventListener('turbolinks:load', () => {
    $('.item').removeClass('active');
    const path = window.location.pathname;
    
    // 企業管理画面のパス判定（URLのプレフィックスで判定）
    if (path.startsWith('/companies')) {
        $('#homeItem').addClass('active');
    } else if (path.startsWith('/company/sales')) {
        $('#parkingSalesListItem').addClass('active');
    } else if (path.startsWith('/company/payments')) {
        $('#parkingPaymentsListItem').addClass('active');
    } else if (path.startsWith('/company/parks')) {
        $('#parkingParksListItem').addClass('active');
    } else if (path.startsWith('/company/mankuus')) {
        $('#parkingMankuuListItem').addClass('active');
    } else if (path.startsWith('/company/passing_license_plates')) {
        $('#parkingLicensePlateListItem').addClass('active');
    } else if (path.startsWith('/company/license_plates')) {
        $('#parkingLicensePlateListItem').addClass('active');
    } else if (path.startsWith('/company/passcodes')) {
        $('#parkingLicensePlateListItem').addClass('active');
    } else if (path.startsWith('/company/bikes')) {
        $('#parkingLicensePlateListItem').addClass('active');
    } else if (path.startsWith('/company/surveillance_cameras')) {
        $('#parkingLicensePlateListItem').addClass('active');
    } else if (path.startsWith('/company/unpaids')) {
        $('#parkingLicensePlateListItem').addClass('active');
    } else if (path.startsWith('/company/qrcodes')) {
        $('#parkingLicensePlateListItem').addClass('active');
    } else if (path.startsWith('/company/seisankis')) {
        $('#parkingLicensePlateListItem').addClass('active');
    } else if (path.startsWith('/company/coupons')) {
        $('#parkingLicensePlateListItem').addClass('active');
    } else {
        // 既存のパス判定
        switch (path) {
            case '/':
                $('#homeItem').addClass('active');
                break;
            case '/license_plates':
                $('#plateListItem').addClass('active');
                break;
            case '/registered_license_plates':
                $('#registeredPlateListItem').addClass('active');
                break;
            case '/notifications':
                $('#notificationListItem').addClass('active');
                break;
            case '/face_attributes':
                $('#faceAttributeBiItem').addClass('active');
                break;
            case '/users/sign_in':
                $('#signInItem').addClass('active');
                break;
            default:
                break;
        }
    }
});
